export default __webpack_public_path__ + "static/media/browser_sign.147a4a20.png";